import { LocalStorage } from '../utils/storage';
import { registerCodesPayloadToMap } from '../utils/registerCodeSuffix';
import { UserPreferences } from './UserPreferencesService';

const setFeatureFlags = (featureFlags) => {
  const flags = featureFlags || [];
  LocalStorage.set('feature_flags', flags);
  LocalStorage.set('featureFlags', flags);
};

export const SessionService = {
  updatePlanAndAccess: (data) => {
    setFeatureFlags(data.feature_flags);
    LocalStorage.set('plan_features', data.plan_features || []);
    LocalStorage.set('subscription_plan_name', data.subscription_plan_formatted_name);
    LocalStorage.set('permissions', data.permissions || []);
    if (data.stock_snapshots_min_date !== undefined) {
      LocalStorage.set('stock_snapshots_min_date', data.stock_snapshots_min_date);
    }
  },

  persistLoginSession: (response, token) => {
    const data = response.data;
    const featureFlags = data.feature_flags || [];
    const expirationDate = `${data.expiration_date}T00:00:00`;

    localStorage.setItem('loginToken', token);
    localStorage.setItem('loginEmail', data.email);
    localStorage.setItem('awsBucketName', data.aws_bucket_name);
    localStorage.setItem('awsSecretAccessKey', data.aws_secret_access_key);
    localStorage.setItem('awsAccessKeyId', data.aws_access_key_id);
    setFeatureFlags(featureFlags);
    LocalStorage.set('customForms', data.custom_forms);
    LocalStorage.set('ControlRecordsForms', data.control_records_forms);
    LocalStorage.set('firstStepsFlags', data.first_steps_flags || []);
    LocalStorage.set('subscribed', data.subscribed);
    LocalStorage.set('trial_period', data.trial_period);
    localStorage.setItem('expiration_date', expirationDate);
    localStorage.setItem('signUpDate', data.sign_up_date);
    LocalStorage.set('permissions', data.permissions);
    LocalStorage.set('plan_features', data.plan_features);
    LocalStorage.set('exceeds_concurrent_users', data.exceeds_concurrent_users);
    LocalStorage.set('subscription_plan_name', data.subscription_plan_formatted_name);
    LocalStorage.set('isAdmin', data.admin);
    LocalStorage.set('isSuperadmin', data.superadmin);
    localStorage.setItem('date_format', data.date_format);
    localStorage.setItem('rows_per_page', data.default_rows_per_page);
    localStorage.setItem('selector_per_page', data.default_selector_per_page);
    localStorage.setItem('user_email', data.email);
    localStorage.setItem('user_first_name', data.first_name);
    localStorage.setItem('user_last_name', data.last_name);
    localStorage.setItem('print_tickets', data.print_tickets);
    localStorage.setItem('language', data.language);
    localStorage.setItem('user_id', data.id);
    localStorage.setItem('organization_id', data.organization_id);
    localStorage.setItem('production_strict_mode', data.production_strict_mode);
    localStorage.setItem('strict_input_date', data.strict_input_date);
    LocalStorage.set('register_codes', registerCodesPayloadToMap(data.register_codes));
    LocalStorage.set('stock_snapshots_min_date', data.stock_snapshots_min_date || null);

    if (data.usa_units) {
      localStorage.setItem('usa_units', data.usa_units);
    }

    UserPreferences.hydrateFromLogin(data.table_column_preferences);
  },
};
